import { useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { toast } from "sonner";
import { IMAGES } from "@/lib/assets";
import { useLanguage } from "@/i18n/LanguageContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Newsletter = () => {
  const { t } = useLanguage();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter`, { email });
      toast.success(t("newsletter.success"));
      setEmail("");
    } catch (err) {
      toast.error(err?.response?.data?.detail || t("newsletter.error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <section data-testid="newsletter-section" className="relative py-28 sm:py-36 overflow-hidden">
      <div className="absolute inset-0">
        <img src={IMAGES.texture} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#0A1420]/85" />
      </div>

      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.9 }}
        className="relative max-w-3xl mx-auto px-6 text-center"
      >
        <p className="text-[#D4AF37] tracking-[0.3em] uppercase text-xs mb-6">
          {t("newsletter.eyebrow")}
        </p>
        <h2 className="font-serif-lux text-4xl sm:text-5xl lg:text-6xl text-white leading-tight">
          {t("newsletter.title")} <span className="gold-gradient-text italic">{t("newsletter.titleAccent")}</span>
        </h2>
        <p className="mt-6 text-[#A0ABC0] font-light text-base sm:text-lg">
          {t("newsletter.subtitle")}
        </p>

        <form
          onSubmit={submit}
          data-testid="newsletter-form"
          className="mt-12 flex flex-col sm:flex-row gap-4 max-w-xl mx-auto"
        >
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t("newsletter.placeholder")}
            data-testid="newsletter-email-input"
            className="flex-1 bg-transparent border-b border-white/20 focus:border-[#D4AF37] text-white py-3 px-0 outline-none transition-colors duration-300 placeholder:text-[#A0ABC0]/60"
          />
          <button
            type="submit"
            disabled={loading}
            data-testid="newsletter-submit-button"
            className="bg-[#D4AF37] text-[#0A1420] font-semibold hover:bg-[#E6C27A] transition-colors duration-300 px-9 py-4 uppercase tracking-widest text-sm disabled:opacity-60"
          >
            {loading ? t("newsletter.submitting") : t("newsletter.submit")}
          </button>
        </form>
      </motion.div>
    </section>
  );
};
